/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// cSpell:ignore adaaccess

import { STATUS } from 'sarsaparilla';

import {
    SET_FETCH_FACILITY_DATA_STATUS,
    FETCH_FACILITY_DATA_SUCCESS,
    FETCH_FACILITY_DATA_ERROR,
} from '../actions/facilityDataActions';

export const initialState = {
    error: null,
    isLoading: true,
    loadingStatus: STATUS.IDLE,
    agency_id: '',
    agency_name: '',
    accepts_passes: false,
    asset_addresses: [],
    asset_links: [],
    booking_window_configs: {},
    change_cancel_desc: '',
    created_date: {},
    facility_id: '',
    facility_adaaccess: '',
    facility_description: '',
    facility_directions: '',
    facility_email: '',
    facility_latitude: 0,
    facility_longitude: 0,
    facility_map_url: '',
    facility_name: '',
    facility_phone: null,
    facility_reservation_url: '',
    facility_timezone: '',
    allow_guest_selection_before_tour_selection: false,
    guest_types: [
        {
            type: 'Adult',
            disabled: true,
            guest_type_id: '__mock_guest_type_1__',
            pass_type: '',
        },
        {
            type: 'Youth',
            disabled: true,
            guest_type_id: '__mock_guest_type_2__',
            pass_type: '',
        },
    ],
    keyword: '',
    last_updated_date: {},
    notes: [],
    parent_asset_id: null,
    parent_asset_name: '',
    purchase_limits: {},
    purchase_minimums: {},
};

export const facilityDataReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_FACILITY_DATA_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_FACILITY_DATA_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        }
        case FETCH_FACILITY_DATA_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        default:
            return state;
    }
};
